import ButtonWithConfirm from "components/Button/ButtonWithConfirm";
import { ButtonProps } from "@chakra-ui/react";
import RedOutlineButton from "components/Button/RedOutlineButton";
import { User } from "features/User/models";
import { useIsCurrentUserCompanyAdmin } from "hooks/useCurrentUserPermissions";
import { useDeactivateUser } from "features/User/hooks";

const CONFIRM_DEACTIVATE_USER = {
  header: "Confirm User Deactivation",
  body: "This cannot be undone! Be sure you want to deactivate this user (they no longer work at your company).",
  confirmButtonText: "Deactivate User",
};

interface DeactivateUserButtonProps extends ButtonProps {
  user: User;
  onSuccess?: (resp: any) => void;
}


export function AdminDeactivateUserButton({ user, onSuccess, ...rest }: DeactivateUserButtonProps) {
  const isAdmin = useIsCurrentUserCompanyAdmin();
  const { mutate: deactivate } = useDeactivateUser(user, onSuccess);

  if (!isAdmin || user?.deactivatedAt) return null;

  return (
    <ButtonWithConfirm
      handleConfirm={() => deactivate()}
      intent="confirmation"
      {...CONFIRM_DEACTIVATE_USER}
    >
      <RedOutlineButton {...rest}>
        Deactivate User
      </RedOutlineButton>
    </ButtonWithConfirm>
  );
}
